/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef } from 'react';
import { CloseSec } from '../../common/svg/AllSvg';
import { useTranslation } from 'react-i18next';
import SecondaryBtn from '../../common/form/SecondaryBtn';
import { useNavigate, useParams } from 'react-router-dom';

const NCMCPopup = ({ ncmcOpen, setNcmcOpen }: any) => {
    const { t } = useTranslation('common');
    const ref: any = useRef();
    const navigate = useNavigate();
    const params = useParams();

    useEffect(() => {
        function handleClickOutside(event: any) {
            if (ref.current && !ref.current.contains(event.target)) {
                setNcmcOpen(false)
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [ref]);

    document.onkeydown = function (evt: any) {
        if (evt.keyCode === 27) {
            setNcmcOpen(false)
        }
    };

    return (
        <>
            {ncmcOpen &&
                <div className="fixed inset-0 z-[34] top-0 w-full h-full overflow-y-auto bg-[rgba(216,216,216,0.60)] backdrop-blur-[15px]">
                    <div className="flex justify-center items-center min-h-screen">
                        <div className="m-[15px] mm:mx-auto w-full sm:w-[600px] md:w-[700px] msm:w-[920px] relative bg-white dark:bg-bgDarkDull rounded-[20px] shadow-[0px_8px_22px_-6px_rgba(24,39,75,0.12),0px_14px_64px_-4px_rgba(24,39,75,0.12)] flex flex-col" ref={ref}>
                            <button aria-label={t("aria_label.close")} title={t("aria_label.close")} className="w-fit h-fit rounded-full focus:shadow-[0_0_0_2px_#D7D8DD] hover:shadow-[0_0_0_2px_#D7D8DD] flex items-center justify-center dark:focus:shadow-[0_0_0_2px_#ffffff5e] dark:hover:shadow-[0_0_0_2px_#ffffff5e] absolute top-[15px] right-[15px] z-[2]" type="button" onClick={() => setNcmcOpen(false)}>
                                <CloseSec />
                            </button>

                            <img src={require('../../../assets/images/ncmc-bg.png')} alt="ncmc-bg" className='absolute bottom-0 left-0 right-0 w-full h-fit rounded-b-[20px]' />

                            <div className='flex sm:items-center gap-[25px] xlx:gap-[40px] justify-between w-full p-[30px] sm:p-[40px] xlx:p-[50px] !pb-[10px] relative z-[1] sm:flex-row flex-col'>
                                <div className='flex flex-col'>
                                    <h1 className='text-primaryText dark:text-white font-bold mb-[8px]'>Tap. Ride. Go.</h1>
                                    <h4 className='text-primary font-bold max-w-[378px] mb-[20px]'>With NCMC on Mumbai Metro Line 3, your journey just got smarter!</h4>

                                    <SecondaryBtn title="Learn More" onClick={() => !!params?.lang ? navigate(`/${params?.lang}/ncmc-on-mumbai-metro-line-3`) : navigate(`/ncmc-on-mumbai-metro-line-3`)} css="w-fit px-[50px] flex items-center justify-center !rounded-[6px] !text-base uppercase font-bold" />
                                </div>

                                <div className="flex flex-col gap-[12px]">
                                    <h5 className="text-blackDull dark:text-textBlackDull font-semibold">Get your NCMC card at these Stations</h5>
                                    <div className="flex items-center flex-wrap gap-[9px] max-w-[370px]">
                                        <div className="border-2 rounded-[8px] xlx:rounded-[12px] flex items-center h-[30px] justify-center px-[12px] xlx:px-[15px] text-sm !leading-tight font-semibold text-secPurple border-secPurple">Aarey JVLR</div>
                                        <div className="border-2 rounded-[8px] xlx:rounded-[12px] flex items-center h-[30px] justify-center px-[12px] xlx:px-[15px] text-sm !leading-tight font-semibold text-secRed border-secRed">Marol Naka</div>
                                        <div className="border-2 rounded-[8px] xlx:rounded-[12px] flex items-center h-[30px] justify-center px-[12px] xlx:px-[15px] text-sm !leading-tight font-semibold text-secOrange border-secOrange">Santacruz Metro</div>
                                        <div className="border-2 rounded-[8px] xlx:rounded-[12px] flex items-center h-[30px] justify-center px-[12px] xlx:px-[15px] text-sm !leading-tight font-semibold text-[#B497E7] border-[#B497E7]">Bandra-Kurla Complex</div>
                                        <div className="border-2 rounded-[8px] xlx:rounded-[12px] flex items-center h-[30px] justify-center px-[12px] xlx:px-[15px] text-sm !leading-tight font-semibold text-secBlue2 border-secBlue2">Dadar Metro</div>
                                        <div className="border-2 rounded-[8px] xlx:rounded-[12px] flex items-center h-[30px] justify-center px-[12px] xlx:px-[15px] text-sm !leading-tight font-semibold text-secGreen border-secGreen">Siddhivinayak</div>
                                    </div>
                                </div>
                            </div>

                            <div className='w-full flex items-center justify-center relative z-[1]'>
                                <img src={require('../../../assets/images/popup-card.png')} alt="card" />
                            </div>
                        </div>
                    </div>
                </div >}
        </>
    );
};

export default NCMCPopup;